"use client"

import { useEffect, useState } from "react"
import { Slider } from "@/components/ui/slider"
import { useTranslations } from "@/lib/i18n/client"

interface RangeDualSliderProps {
  min: number
  max: number
  step?: number
  value: [number, number]
  onCommit: (value: [number, number]) => void
  format: (n: number) => string
  ariaLabel?: string
}

export function RangeDualSlider({
  min,
  max,
  step = 1,
  value,
  onCommit,
  format,
  ariaLabel,
}: RangeDualSliderProps) {
  const { t } = useTranslations()
  const [local, setLocal] = useState<[number, number]>(value)

  useEffect(() => {
    setLocal(value)
  }, [value[0], value[1]]) // eslint-disable-line react-hooks/exhaustive-deps

  const minLabel = ariaLabel ? `${t.common.min} ${ariaLabel}` : t.common.min
  const maxLabel = ariaLabel ? `${t.common.max} ${ariaLabel}` : t.common.max

  return (
    <div>
      <Slider
        min={min}
        max={max}
        step={step}
        value={local}
        onValueChange={(v) => setLocal([v[0] ?? min, v[1] ?? max])}
        onValueCommit={(v) => onCommit([v[0] ?? min, v[1] ?? max])}
        minStepsBetweenThumbs={1}
        thumbLabels={[minLabel, maxLabel]}
        className="[&_[data-slot=slider-track]]:h-[3px] [&_[data-slot=slider-track]]:bg-slate-200 [&_[data-slot=slider-range]]:bg-navy-800 [&_[data-slot=slider-thumb]]:size-5 [&_[data-slot=slider-thumb]]:border-2 [&_[data-slot=slider-thumb]]:border-navy-800 [&_[data-slot=slider-thumb]]:bg-white sm:[&_[data-slot=slider-thumb]]:size-4"
      />
      <div className="mt-2 flex items-center justify-between font-mono text-xs text-slate-700">
        <span>{format(local[0])}</span>
        <span>{format(local[1])}</span>
      </div>
    </div>
  )
}
